import { render, staticRenderFns } from "./TransactionHistoryTab.vue?vue&type=template&id=9946319e&"
import script from "./TransactionHistoryTab.vue?vue&type=script&lang=js&"
export * from "./TransactionHistoryTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports